import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "log-red"
}


import { RequestInfo } from '@/types/Request';
import { getLogMessageValue }  from '@/utils/getValueForKey';


export default /*@__PURE__*/_defineComponent({
  __name: 'HistoryList',
  props: {
    data: {}
  },
  emits: ["open-image-viewer"],
  setup(__props: any, { emit: __emit }) {



const emits = __emit;

const openImageViewer = (image: string) => {
  emits('open-image-viewer', image);
};


return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    data: _ctx.data.history,
    "default-sort": { prop: 'regDate', order: 'descending' },
    style: {"width":"100%"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        prop: "regDate",
        label: "변경일시",
        width: "160",
        align: "center"
      }),
      _createVNode(_component_el_table_column, {
        prop: "actionType",
        label: "수행자",
        width: "240"
      }),
      _createVNode(_component_el_table_column, { label: "변경 내용" }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(_unref(getLogMessageValue)(scope.row.logType)) + " ", 1),
          (scope.row.logType === 'CREATED_EAGLE_PLAN' || scope.row.logType === 'CREATED_EAGLE_PV' || scope.row.logType === 'CREATED_EAGLE_JAM' || scope.row.logType === 'COMPLETED_PAYMENT_CARD')
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                _createVNode(_component_el_button, {
                  text: "",
                  "aria-label": "이미지 보기",
                  onClick: ($event: any) => (openImageViewer(scope.row.image))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-regular fa-image" })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]))
            : _createCommentVNode("", true),
          (scope.row.logType === 'COMPLETED_PAYMENT_WIRE'|| scope.row.logType === 'COMPLETED_PAYMENT_WIRE_DELAY')
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, " (입금일: " + _toDisplayString(scope.row.actualPaymentDate) + ") ", 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})